import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  graphapiToken: {},
  allSites: [],
  sitesByName: [],
  siteList: [],
  siteListByName: [],
  sharepointDriveBySite: {},
  subscriptionOfList: [],
  registerIntegrations: {},
  webhookIntegrationsByID: {},
  deletedWebhookIntegrationsByID: {},
  renewedWebhookIntegrationsByID: {},
  webhookIntegrationsExpiration: {},
  primaryWebhookIntegrations: {},
  sharepointNotification: {},
  metadataStatus: [],
  metadataSync: '',
  selectedFolderName: '',
  imagePreview: [],
  renameFile: '',
  customerFolders: [],
  currentDirectory: [],
  currentDirectoryBySiteId: {},
  duplicateFile: {},
  moveFileToFolder: [],
  archivedFile: {},
  restoredFile: {},
  customerDirectory: [],
  diagramsDirectory: [],
  currentPath: '',
  customerCurrentFolderItems: [],
  fileProperties: {},
  folderProperties: {},
  downloadFile: {},
  renameFolder: {},
  duplicateFolder: {},
  createNewFolder: {},
  movedFolder: {},
  uploadFile: {},
  folders: {},
  viewerData: {},
  newFolderToggle: false,
  renameFileToggle: false,
  archiveToggle: false,
  renameFolderToggle: false,
  filePropertiesToggle: false,
  fileFolderToggle: false,
  recyclingBinToggle: false,
  uploadNewFileToggle: false,
  moveFileErrorToggle: false,
  uploadFileToggle: false,
  toggleModal: false,
  toggleIntegrationsInformationModal: false,
  isLoading: false,
  isUploading: false,
  isDetailDiagramLoaded: false,
  folderPropertiesToggle: false,
  propertiesData: [],
  propertiesToggle: false,
  editDiagramToggle: false,
  image: {},
  currentTarget: null,
  error: [],
  moveFile: null,
  moveToRecycleBin: null,
  restoreFile: null,
  // states for new reducers
  toggleRestoreItem: false,
  isLoadingBySiteId: false,
};

const graphApiSlice = createSlice({
  name: 'graphApi',
  initialState,
  reducers: {
    start: (state, action) => {
      state.isLoading = true;
      state.error = [];
    },
    startBySiteId: (state, action) => {
      state.isLoadingBySiteId = true;
      state.error = [];
    },
    graphImageStart: (state, action) => {
      state.isDetailDiagramLoaded = false;
      state.isLoading = true;
      state.error = [];
    },
    graphApiUploadFileStart: (state, action) => {
      state.isUploading = true;
      state.error = [];
    },
    setReducerError: (state, action) => {
      state.error = action.error;
      state.isLoading = false;
      state.isLoadingBySiteId = false;
    },
    setGraphImageError: (state, action) => {
      state.error = action.error;
      state.isLoading = false;
      state.isDetailDiagramLoaded = false;
    },
    setGraphUploadFileError: (state, action) => {
      state.error = action.error;
      state.isUploading = false;
    },
    resetGraphApiImagePreviewUrl: (state, action) => {
      state.imagePreview = [];
      state.isLoading = false;
    },
    setImage: (state, action) => {
      state.image = action.payload;
      state.isLoading = false;
      state.isDetailDiagramLoaded = true;
      state.error = [];
    },
    setUploadFile: (state, action) => {
      state.uploadFile = action.payload;
      state.isLoading = false;
      state.isUploading = false;
      state.error = [];
    },
    setImagePreview: (state, action) => {
      state.imagePreview = [...state.imagePreview, action.payload];
      state.isLoading = false;
      state.error = [];
    },
    setCurrentTarget: (state, action) => {
      state.currentTarget = action.payload;
    },
    setGraphApiToken: (state, action) => {
      state.graphapiToken = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setAllSites: (state, action) => {
      state.allSites = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setSitesByName: (state, action) => {
      state.sitesByName = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setSiteList: (state, action) => {
      state.siteList = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setSiteListByName: (state, action) => {
      state.siteListByName = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setSharePointDriveBySite: (state, action) => {
      state.sharepointDriveBySite = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setSubscriptionOfList: (state, action) => {
      state.subscriptionOfList = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setRegisterIntegrations: (state, action) => {
      state.registerIntegrations = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setWebhookIntegrationsByID: (state, action) => {
      state.webhookIntegrationsByID = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setDeletedWebhookIntegrationsByID: (state, action) => {
      state.deletedWebhookIntegrationsByID = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setRenewedWebhookIntegrationsByID: (state, action) => {
      state.renewedWebhookIntegrationsByID = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setRenameFile: (state, action) => {
      state.renameFile = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setWebhookIntegrationsExpiration: (state, action) => {
      state.webhookIntegrationsExpiration = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setPrimaryWebhookIntegrations: (state, action) => {
      state.primaryWebhookIntegrations = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setSharepointNotification: (state, action) => {
      state.sharepointNotification = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setToggleModal: (state, action) => {
      state.toggleModal = !state.toggleModal;
    },
    setToggleIntegrationsInformationModal: (state, action) => {
      state.toggleIntegrationsInformationModal = !state.toggleIntegrationsInformationModal;
    },
    setMetaDataStatus: (state, action) => {
      state.metadataStatus = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setMetadataSync: (state, action) => {
      state.metadataSync = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setFolders: (state, action) => {
      state.folders = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCurrentDirectory: (state, action) => {
      state.currentDirectory = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCurrentDirectoryBySiteId: (state, action) => {
      state.currentDirectoryBySiteId = action.payload;
      state.isLoadingBySiteId = false;
      state.error = [];
    },
    setCustomerDirectory: (state, action) => {
      state.customerDirectory = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setFileProperties: (state, action) => {
      state.fileProperties = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCurrentPath: (state, action) => {
      state.currentPath = action.payload;
      state.fileProperties = null;
      state.isLoading = false;
    },
    setDiagramsDirectory: (state, action) => {
      state.diagramsDirectory = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setDuplicateFile: (state, action) => {
      state.duplicateFile = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setMoveFile: (state, action) => {
      state.moveFile = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setMoveToRecycleBin: (state, action) => {
      state.moveToRecycleBin = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setRestoreFile: (state, action) => {
      state.restoreFile = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setFolderProperties: (state, action) => {
      state.folderProperties = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setDownloadFile: (state, action) => {
      state.downloadFile = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setDuplicateFolder: (state, action) => {
      state.duplicateFile = action.payload; // state review
      state.isLoading = false;
      state.error = [];
    },
    setCreateNewFolder: (state, action) => {
      state.createNewFolder = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setMovedFolder: (state, action) => {
      state.movedFolder = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setFilePropertiesToggle: (state, action) => {
      state.filePropertiesToggle = action.payload;
      state.isLoading = false;
    },
    setArchiveToggle: (state, action) => {
      state.archiveToggle = action.payload;
      state.isLoading = false;
    },
    setFolderPropertiesToggle: (state, action) => {
      state.folderPropertiesToggle = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setPropertiesToggle: (state, action) => {
      state.propertiesToggle = action.payload;
      state.isLoading = false;
    },
    setPropertiesData: (state, action) => {
      state.propertiesData = action.payload;
      state.isLoading = false;
    },
    setRenameFileToggle: (state, action) => {
      state.renameFileToggle = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setNewFolderToggle: (state, action) => {
      state.newFolderToggle = action.payload;
      state.isLoading = false;
    },
    setRecyclingBinToggle: (state, action) => {
      state.recyclingBinToggle = action.payload;
      state.isLoading = false;
    },
    setRenameFolderToggle: (state, action) => {
      state.renameFolderToggle = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setEditDiagramToggle: (state, action) => {
      state.editDiagramToggle = !state.editDiagramToggle;
      state.isLoading = false;
      state.error = [];
    },
    setMoveFileErrorToggle: (state, action) => {
      state.moveFileErrorToggle = action.payload;
      state.isLoading = false;
    },
    setUploadFileToggle: (state, action) => {
      state.uploadFileToggle = action.payload;
      state.isLoading = false;
    },
    setViewerData: (state, action) => {
      state.viewerData = action.payload;
      state.isLoading = false;
    },
    setSelectedFolderName: (state, action) => {
      state.selectedFolderName = action.payload;
      state.isLoading = false;
    },
    setToggleRestoreItem: (state, action) => {
      state.toggleRestoreItem = action.payload;
    },
    setResetGraphApi: () => {
      return initialState;
    },
  },
});

export const {
  start,
  graphImageStart,
  graphApiUploadFileStart,
  setCurrentDirectoryBySiteId,
  setViewerData,
  startBySiteId,
  setReducerError,
  setGraphImageError,
  setGraphUploadFileError,
  setArchiveToggle,
  resetGraphApiImagePreviewUrl,
  setImage,
  setPropertiesToggle,
  setPropertiesData,
  setImagePreview,
  setCurrentTarget,
  setGraphApiToken,
  setAllSites,
  setSitesByName,
  setSiteList,
  setSiteListByName,
  setSharePointDriveBySite,
  setSubscriptionOfList,
  setRegisterIntegrations,
  setWebhookIntegrationsByID,
  setDeletedWebhookIntegrationsByID,
  setRenewedWebhookIntegrationsByID,
  setRenameFile,
  setWebhookIntegrationsExpiration,
  setPrimaryWebhookIntegrations,
  setSharepointNotification,
  setToggleModal,
  setToggleIntegrationsInformationModal,
  setMetaDataStatus,
  setMetadataSync,
  setFolders,
  setCurrentDirectory,
  setCustomerDirectory,
  setFileProperties,
  setCurrentPath,
  setDiagramsDirectory,
  setDuplicateFile,
  setMoveFile,
  setMoveToRecycleBin,
  setRestoreFile,
  setFolderProperties,
  setDownloadFile,
  setDuplicateFolder,
  setCreateNewFolder,
  setMovedFolder,
  setFilePropertiesToggle,
  setFolderPropertiesToggle,
  setRenameFileToggle,
  setNewFolderToggle,
  setRecyclingBinToggle,
  setRenameFolderToggle,
  setEditDiagramToggle,
  setMoveFileErrorToggle,
  setUploadFile,
  setUploadFileToggle,
  // newly created reducers
  setToggleRestoreItem,
  setResetGraphApi,
  setSelectedFolderName,
} = graphApiSlice.actions;

export default graphApiSlice.reducer;
